/* global window, $ */
angular.
module("digiexam.components").
directive("studentlibrary", function studentlibraryDirective(
	DX_STUDENT_SORT_PREDICATE,

	dxLocalize
) {
	"use strict";

	return {
		restrict: "E",
		templateUrl: "directives/studentlibrary.html",
		replace: true,

		link: function link($scope) {
			var KEY_UP = 38;
			var KEY_DOWN = 40;
			var KEY_RIGHT = 39;
			var KEY_LEFT = 37;
			var KEY_CTRL = 17;
			var KEY_ALT = 18;

			var ALT_MODIFIER = false;
			var CTRL_MODIFIER = false;

			function isElementRequiringModifier(el) {
				var type = el.tagName.toUpperCase();
				return type === "INPUT" || type === "TEXTAREA";
			}

			$(window).on("keydown.studentlibrary", function onKeydown(event) {
				var key = event.which;

				if (key === KEY_CTRL) {
					CTRL_MODIFIER = true;
				} else if (key === KEY_ALT) {
					ALT_MODIFIER = true;
				}

				if (isElementRequiringModifier(event.target) && !ALT_MODIFIER && !CTRL_MODIFIER) {
					return;
				}

				if ([KEY_RIGHT, KEY_LEFT, KEY_UP, KEY_DOWN].includes(key)) {
					event.preventDefault();
				}
			});

			$(window).on("keyup.studentlibrary", function onKeyup(event) {
				var key = event.which;

				if (key === KEY_CTRL) {
					CTRL_MODIFIER = false;
				} else if (key === KEY_ALT) {
					ALT_MODIFIER = false;
				}

				if (isElementRequiringModifier(event.target) && !ALT_MODIFIER && !CTRL_MODIFIER) {
					return;
				}

				if ([KEY_RIGHT, KEY_LEFT, KEY_UP, KEY_DOWN].includes(key)) {
					event.preventDefault();
				}

				switch (key) {
					case KEY_RIGHT:
						$scope.moveRight();
						$scope.$apply();
						break;
					case KEY_LEFT:
						$scope.moveLeft();
						$scope.$apply();
						break;
					case KEY_UP:
						$scope.moveUp();
						$scope.$apply();
						break;
					case KEY_DOWN:
						$scope.moveDown();
						$scope.$apply();
						break;
				}
			});

			$scope.cleanup = function cleanup() {
				$(window).off(".studentlibrary");
			};
		},
		controller: function controller($scope) {
			var STUDENT_DOM_WIDTH = 70;
			$scope.left = 0;
			$scope.sortOptions = [
				{predicate: DX_STUDENT_SORT_PREDICATE.FIRST_NAME, name: dxLocalize.get("FirstName")},
				{predicate: DX_STUDENT_SORT_PREDICATE.LAST_NAME, name: dxLocalize.get("LastName")}];

			var preferredOrder = $scope.getPreference($scope.ORDER_PREFERENCE_KEY);
			$scope.sortBy = preferredOrder ? preferredOrder : $scope.sortOptions[1];

			// Navigation methods listeners.
			$scope.moveLeft = function moveLeft() {
				var student = $scope.getStudentByIndex($scope.selectedStudentIndex - 1);
				if (student) {
					$scope.selectStudent(student);
					$scope.left += STUDENT_DOM_WIDTH;
				}
			};

			$scope.moveRight = function moveRight() {
				var student = $scope.getStudentByIndex($scope.selectedStudentIndex + 1);
				if (student) {
					$scope.selectStudent(student);
					$scope.left -= STUDENT_DOM_WIDTH;
				}
			};

			$scope.moveUp = function moveUp() {
				var index = $scope.selectedQuestionIndex;
				if ($scope.state.isFinalGradeSelected) {
					index = $scope.questions.length;
				}
				if (index <= 0) {
					return;
				}
				$scope.selectQuestionByIndex(index - 1);
			};

			$scope.moveDown = function moveDown() {
				if ($scope.state.isFinalGradeSelected) {
					return;
				}
				if ($scope.selectedQuestionIndex >= $scope.questions.length - 1) {
					$scope.selectFinalGrade();
				} else {
					$scope.selectQuestionByIndex($scope.selectedQuestionIndex + 1);
				}
			};

			$scope.$watch("selectedStudentIndex", function onSelectedStudentIndex(newIndex) {
				if (newIndex === null) {
					return;
				}
				$scope.left = -(newIndex * STUDENT_DOM_WIDTH);
			});

			$scope.$watch("sortBy", function sortByWatch(newOrder) {
				$scope.sortStudents(newOrder);
				$scope.savePreference($scope.ORDER_PREFERENCE_KEY, newOrder);
			});

			$scope.$on("$destroy", function onDestroy() {
				$scope.cleanup();
			});
		},
	};
});
